import React from 'react';

function VkDialogsIcon({ w, h, style, className }) {
  return (
    <svg
      className={className}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#55759F" cx="18" cy="18" r="18" />
        <path
          d="M26.152 18.302s3.11-4.388 3.42-5.83c.102-.515-.124-.803-.66-.803h-2.698c-.618 0-.845.267-1.03.658 0 0-1.46 3.11-3.234 5.067-.57.634-.86.824-1.174.824-.254 0-.37-.212-.37-.784V12.43c0-.7-.083-.905-.66-.905H15.42c-.33 0-.535.19-.535.453 0 .66 1.01.808 1.01 2.595v3.687c0 .742-.042 1.03-.392 1.03-.927 0-3.13-3.192-4.367-6.818-.248-.74-.515-.947-1.216-.947H7.222c-.39 0-.68.267-.68.66 0 .72.845 4.057 4.16 8.527 2.226 3.007 5.15 4.634 7.787 4.634 1.606 0 1.997-.267 1.997-.947V22.09c0-.577.227-.824.557-.824.37 0 1.025.12 2.554 1.627 1.813 1.73 1.936 2.45 2.925 2.45h3.028c.31 0 .598-.143.598-.658 0-.68-.886-1.895-2.245-3.337-.556-.74-1.463-1.545-1.75-1.915-.413-.433-.29-.68 0-1.133"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

VkDialogsIcon.defaultProps = {
  w: 36,
  h: 36,
};

export default VkDialogsIcon;
